import get from 'lodash.get';
import { trackEcommerce, trackEvent } from 'dibs-tracking';
import { getIsFreeShipping } from 'dibs-search-product-tile/exports/freeShippingHelpers';

const MAX_IMPRESSION_GROUP_COUNT = 20;

const getImpressionGroups = nodes =>
    nodes.reduce((groups, { node }, index) => {
        const group = Math.floor(index / MAX_IMPRESSION_GROUP_COUNT);
        if (!groups[group]) {
            groups[group] = {
                tracked: false,
                items: [],
            };
        }
        groups[group].items.push(node.item);
        return groups;
    }, {});

const trackRelatedItems = ({ items = [], type, searchTerm, startIndex, userRegions }) => {
    trackEcommerce({
        type,
        actionField: { list: 'null results - related items' },
        products: items.map((item, index) => {
            const isFreeShipping = getIsFreeShipping({ item, userRegions });
            return {
                brand: get(item, 'seller.serviceId'),
                category: item.browseUrl,
                categoryCode: item.categoryCode,
                id: item.serviceId,
                name: item.title,
                list: 'null results - related items',
                dimension83: item.contemporaryTrackingString,
                dimension98: searchTerm,
                dimension106: isFreeShipping ? 'Y' : 'N',
                position: startIndex + index + 1,
                url: item.link || '',
            };
        }),
    });
};

export const trackNullSearchRelatedItemProvider = ({ nodes = [], searchTerm, userRegions }) => {
    const impressionGroups = getImpressionGroups(nodes);

    return {
        trackNullSearchRelatedItemsLoad: () => {
            if (nodes.length && searchTerm) {
                trackEvent({
                    label: searchTerm,
                    category: 'product list',
                    action: 'null results related items',
                });
            }
        },
        trackNullSearchRelatedItemClick: ({ item, index }) => {
            trackRelatedItems({
                searchTerm,
                items: [item],
                type: 'productClick',
                startIndex: index + 1,
                userRegions,
            });
        },
        trackNullSearchRelatedItemsImpressions: ({ index }) => {
            const group = Math.floor(index / MAX_IMPRESSION_GROUP_COUNT);
            const { tracked, items: groupItems } = impressionGroups[group];
            if (!tracked) {
                trackRelatedItems({
                    searchTerm,
                    items: groupItems,
                    startIndex: group * MAX_IMPRESSION_GROUP_COUNT,
                    type: 'productImpression',
                    userRegions,
                });
                impressionGroups[group].tracked = true;
            }
        },
    };
};
